import Decimal from "decimal.js";
/**
 * Decimal.js does not support structuredClone and can therefore not be copied during message passing.
 * @param obj
 */
export function serializeMessage(obj) {
    if (Decimal.isDecimal(obj))
        return { __decimal__: obj.toString() };
    if (Array.isArray(obj))
        return obj.map(serializeMessage);
    if (obj && typeof obj === 'object')
        return Object.fromEntries(Object.entries(obj).map(([k, v]) => [k, serializeMessage(v)]));
    return obj;
}
/**
 * Reverses the effect of serializeMessage.
 * @param obj
 */
export function deserializeMessage(obj) {
    if (obj && obj.__decimal__)
        return new Decimal(obj.__decimal__);
    if (Array.isArray(obj))
        return obj.map(deserializeMessage);
    if (obj && typeof obj === 'object')
        return Object.fromEntries(Object.entries(obj).map(([k, v]) => [k, deserializeMessage(v)]));
    return obj;
}
//# sourceMappingURL=entry.js.map